import { Progress } from "@/components/ui/progress";
import { STATUS, eur, fmtDate, num } from "@/lib/api";
import { StatusBadge } from "./StatusBadge";

export function ClubCard({ me }) {
  const s = STATUS[me.status] || STATUS.bronze;
  const nextTh = me.next_level === "gold" ? 1000 : me.next_level === "diamond" ? 5000 : null;
  const pct = nextTh ? Math.min(100, (me.earned_this_year / nextTh) * 100) : 100;
  return (
    <div data-testid="club-card-widget" className={`shine relative overflow-hidden rounded-3xl border bg-gradient-to-br p-6 sm:p-8 ${s.card} ${s.ring}`}
      style={{ boxShadow: `0 20px 60px -20px ${s.color}55` }}>
      <div className="flex items-start justify-between">
        <div>
          <p className="font-club text-xs text-slate-400">CLUB PREZZI</p>
          <p className="mt-1 font-display text-lg font-semibold text-white">{me.full_name || me.email}</p>
        </div>
        <StatusBadge status={me.status} />
      </div>
      <div className="mt-10 grid grid-cols-2 gap-6">
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-400">Saldo punti</p>
          <p data-testid="club-card-balance" className="mt-1 font-display text-4xl font-bold" style={{ color: s.color }}>{num(me.balance)}</p>
          <p className="text-sm text-slate-400">valgono <span data-testid="club-card-value" className="font-semibold text-white">{eur(me.balance_value)}</span></p>
        </div>
        <div className="text-right">
          <p className="text-xs uppercase tracking-widest text-slate-400">Status valido fino al</p>
          <p data-testid="club-card-valid-until" className="mt-1 font-display text-lg text-white">{me.valid_until ? fmtDate(me.valid_until) : "Sempre"}</p>
          <p className="text-xs text-slate-500">Punti {new Date().getFullYear()}: {num(me.earned_this_year)}</p>
        </div>
      </div>
      <div className="mt-8">
        <Progress value={pct} className="h-2 bg-white/10" />
        <p data-testid="club-card-next" className="mt-2 text-xs text-slate-400">
          {me.next_level
            ? `Ancora ${num(me.points_to_next)} punti quest'anno per diventare ${STATUS[me.next_level].label}`
            : "Hai raggiunto il livello massimo quest'anno!"}
        </p>
      </div>
    </div>
  );
}
